import { App, Modal } from "antd";
import { FC, useRef } from "react";
import { useTranslation } from "react-i18next";
import { TimeRangeSelector, TimeRangeSelectorRef } from "./TimeRangeSelector";
import { QuotationRequest } from "@/types/requirement";
import apis from "@/apis/quotationRequestItem";


interface LazyQuateProps {
    quotation: QuotationRequest;
    cb: (newQuotation: QuotationRequest | null) => void;
}
const LazyQuate: FC<LazyQuateProps> = ({ quotation, cb }) => {

    const { t } = useTranslation();
    const { notification } = App.useApp();

    const timeSelectorRef = useRef<TimeRangeSelectorRef>(null);
    const handleOk = () => {
        if (timeSelectorRef.current) {
            const deadlineTimestamp = timeSelectorRef.current.getDeadlineTime().valueOf();

            apis
                .lazyQuotateApi(quotation.id, deadlineTimestamp)
                .then((res) => {
                    notification.success({ placement: 'top', message: t('requirement.lazyQuotaSuc') });
                    cb(res)
                })
                .catch(() => {
                    notification.error({ placement: 'top', message: t('requirement.lazyQuotaErr') });
                });
        }
    };


    return <Modal
        title={t('requirement.lazyQuota')}
        open={true}
        onOk={handleOk}
        onCancel={() => cb(null)}
        width={600}
    >
        <TimeRangeSelector ref={timeSelectorRef} ddlTime={quotation.deadline} />
    </Modal>
}

export default LazyQuate;